import { Toast } from 'antd-mobile';
import { readerImage } from '@/asset/js/utils';
import {
  festivalOfSacrificeInfo,
  festivalOfSacrificeUpdateRoastLamb,
  festivalOfSacrificeLambRemindInfo,
  festivalOfSacrificeDrawInfo,
  festivalOfSacrificeRank,
  festivalOfSacrificeLambInfo,
  festivalOfSacrificeUpdateDraw,
  festivalOfSacrificeTaskInfo,
  festivalOfSacrificeRecordInfo,
  festivalOfSacrificeRoastBroadcast,
  festivalOfSacrificeCatchInfo,
  festivalOfSacrificeCatchLamb,
} from '@/services/activity';

export default {
  namespace: 'activityFestivalOfSacrifice',
  state: {
    endTime: 0,
    title: '',
    titleUrl: '',
    rules: '',
    ranks: [],
    daysInfo: [],
    selfInfo: {},
    receiveRewards: [],
    sendRewards: [],
    lastId: '',
    isMore: false,
    status: 0,
    pageNum: 1,
    pageSize: 20,
    detailsMap: [],
    countDown: 0,
    wordArtUrl: '',
    synthesisCount: 0,
    synthesisFinishCount: 0,
    itemList: [],
    challengeRewards: [],
    drawButtons: [],
    ticketsNum: 0,
    drawItems: [],
    taskList: [],
    roomId: '',
    showTip: false,
    synthesisCountTip: 0,
    broadcasts: [],
    broadcastsLamb: [],
    timeState: 0,
    openState: 0,
    progress: 0,
    personalState: 0,
    scoreRate: 0,
    retainCatchCount: 0,
    personalStateDesc: '',
    personalStateTipDesc: '',
    totalCatchCount: 0,
    activityId: '',
    freeGifts: [],
    roastLambDailyRewards: [],
    roastLambTotalRewards: [],
    dailyRewards: [],
    totalRewards: [],
    limitedGifts: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: 0,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        wordArtUrl: payload.wordArtUrl || '',
        roomId: payload.roomId || '',
        daysInfo: payload.daysInfo || [],
        roastLambDailyRewards: payload.roastLambDailyRewards || [],
        roastLambTotalRewards: payload.roastLambTotalRewards || [],
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
        limitedGifts: payload.limitedGifts || [],
      };
    },
    updateLambInfo(state, { payload }) {
      return {
        ...state,
        synthesisCount: payload.synthesisCount || 0,
        synthesisFinishCount: payload.synthesisFinishCount || 0,
        itemList: payload.itemList || [],
        challengeRewards: payload.challengeRewards || [],
      };
    },
    updateDrawInfo(state, { payload }) {
      return {
        ...state,
        drawButtons: payload.drawButtons || [],
        ticketsNum: payload.ticketsNum || 0,
        drawItems: payload.drawItems || [],
      };
    },
    updateTicketInfo(state, { payload }) {
      return {
        ...state,
        ticketsNum: payload.ticketsNum || 0,
      };
    },
    updateTaskInfo(state, { payload }) {
      return {
        ...state,
        taskList: payload.taskList || [],
      };
    },
    updateTipInfo(state, { payload }) {
      return {
        ...state,
        showTip: payload.showTip || false,
        synthesisCountTip: payload.synthesisCount || 0,
      };
    },
    updateBroadcasts(state, { payload }) {
      return {
        ...state,
        broadcasts: payload.source === 3 ? payload.data : [],
        broadcastsLamb: payload.source === 5 ? payload.data : [],
      };
    },
    updateCatchInfo(state, { payload }) {
      return {
        ...state,
        timeState: payload.timeState || 0,
        openState: payload.openState || 0,
        progress: payload.progress || 0,
        personalState: payload.personalState || 0,
        scoreRate: payload.scoreRate || 0,
        retainCatchCount: payload.retainCatchCount || 0,
        personalStateDesc: payload.personalStateDesc || '',
        freeGifts: payload.freeGifts || [],
        totalCatchCount: payload.totalCatchCount || 0,
        personalStateTipDesc: payload.personalStateTipDesc || '',
      };
    },
    updateRemianCount(state, { payload }) {
      return {
        ...state,
        retainCatchCount: payload.retainCatchCount || 0,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
    updateDetailList(state, { payload }) {
      let newList = payload.force ? [] : [...state.detailsMap];
      let isMore = false;
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
        isMore = payload.records.length >= state.pageSize;
      }
      return {
        ...state,
        detailsMap: newList,
        pageNum: payload.pageNum || 1,
        isMore: isMore || false,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getLambInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeLambInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateLambInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateLambInfo',
        payload: data,
      });
      return true;
    },
    *getDrawInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeDrawInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateDrawInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      // 处理抽奖的图片大小
      if (data && Array.isArray(data.drawItems)) {
        for (let i = 0; i < data.drawItems.length; i++) {
          // 如果不存在图片，就跳过，防止因为图片没配置导致页面报错加载不出页面问题
          if (!data.drawItems[i].image) {
            continue;
          }
          const { width, height } = yield readerImage(data.drawItems[i].image);
          let w = 60;
          let h = 60;
          let t = 10;
          if (width > height) {
            h = (height / width) * w;
            t = (59 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 60;
            h = 60;
          }
          data.drawItems[i].w = w;
          data.drawItems[i].h = h;
          data.drawItems[i].t = t;
        }
      }
      yield put({
        type: 'updateDrawInfo',
        payload: data,
      });
      return true;
    },
    *getTaskInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeTaskInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateTaskInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTaskInfo',
        payload: data,
      });
      return true;
    },
    *getCatchInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeCatchInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateCatchInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateCatchInfo',
        payload: data,
      });
      return true;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityFestivalOfSacrifice);
      const { error, data } = yield call(festivalOfSacrificeRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
    *getDetailList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.activityFestivalOfSacrifice);
      const { error, data } = yield call(festivalOfSacrificeRecordInfo, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateDetailList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDetailList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      });
      return true;
    },
    *getTipInfo({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeLambRemindInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateTipInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTipInfo',
        payload: data,
      });
      return true;
    },
    *getBroadcast({ payload }, { call, put }) {
      const { error, data } = yield call(festivalOfSacrificeRoastBroadcast, payload);
      if (error || !data) {
        yield put({
          type: 'updateBroadcasts',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBroadcasts',
        payload: {
          data: data,
          source: payload.source,
        },
      });
      return true;
    },
    *updateDraw({ payload }, { call, put }) {
      const { data, error } = yield call(festivalOfSacrificeUpdateDraw, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateTicketInfo',
          payload: { ...data },
        });
        return {
          success: true,
          data,
        };
      }
    },
    *updateRoastLamb({ payload }, { call, put }) {
      const { data, error } = yield call(festivalOfSacrificeUpdateRoastLamb, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return error;
      }
      return {
        success: true,
        data,
      };
    },
    *updateCatchLamb({ payload }, { call, put }) {
      const { data, error } = yield call(festivalOfSacrificeCatchLamb, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return error;
      }
      yield put({
        type: 'updateRemianCount',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
  },
};
